import {
  Box,
  Button,
  Flex,
  FormControl,
  FormErrorMessage,
  FormLabel,
  HStack,
  Input,
  Select,
  Table,
  Tbody,
  Td,
  Text,
  Thead,
  Tr,
  useToast
} from "@chakra-ui/react";
import { useFormik } from "formik";
import { useEffect, useRef, useState } from "react";
import { IUserEducation } from "../../../models/usereducation.model";
import trainerRegistration from "../../../services/trainer/trainerRegistration";
import usereducationService from "../../../services/usereducation.service";
import { classOfDegree, degrees } from "../../../utils/classOfDegree";
import { Years } from "../../../utils/years";

const EducationProfile = ({
  nextPage,
  prePage,
  ...rest
}: {
  nextPage: any;
  prePage: any;
}) => {
  const [gender, setGender] = useState<any[]>([]);
  const [cod, setClassofdegree] = useState<any[]>([]);
  const [degree, setDegree] = useState<any[]>([]);
  const [years, setYears] = useState<any[]>([]);
  const [education, setEducation] = useState<IUserEducation>();
  const [loading, setLoading] = useState(true);
  const toast = useToast();
  const inputRef = useRef<HTMLInputElement | null>(null);
  const [isUploading, setIsUploading] = useState<boolean>(false);
  const [uploadFileSize, setUploadFileSize] = useState("");
  const [batchFile, setbatchFile] = useState<File | null>();
  const [filename, setFilename] = useState("");

  useEffect(() => {
    usereducationService.getUserEducation().then((res) => {
      setEducation(res.data[res.data.length - 1]);
      setLoading(false);
      setUserEducation();
    });
    setYears(Years());
    setClassofdegree(classOfDegree());
    setDegree(degrees());
    const maingender = [
      {
        id: "1",
        title: "male",
      },
      {
        id: "2",
        title: "female",
      },
    ];
    setGender(maingender);
  }, [education?.id]);

  const formik = useFormik({
    validate: (values: any) => {
      const errors: any = {};
      if (!values.institutionName) {
        errors.institutionName = "Name of institution is required";
      }
      if (!values.courseDiscipline) {
        errors.courseDiscipline = "Course / Discipline is required";
      }
      if (!values.yearObtained) {
        errors.yearObtained = "Year Obtained is required";
      }
      return errors;
    },
    // initialValues: {
    //     institutionName: education?.institution ? education?.institution : "",
    //     courseDiscipline: education?.discipline ? education?.discipline : "",
    //     programOfStudy: education?.program ? education?.program : "",
    //     classOfDegree: education?.class_of_degree ? education?.class_of_degree : "",
    //     yearObtained: education?.year ? education?.year : "",
    //     degree: education?.degree ? education?.degree : "",
    //     certificate: education?.doc ? education?.doc : "",
    // },
    initialValues: {
      institutionName: education?.institution || "",
      courseDiscipline: education?.discipline || "",
      programOfStudy: education?.program || "",
      classOfDegree: education?.class_of_degree || "",
      yearObtained: education?.year || "",
      degree: education?.degree || "",
      certificate: education?.doc || "",
    },
    onSubmit: async (values) => {
      if (batchFile) {
        const formData = new FormData();
        formData.append("doc", batchFile);
        formData.append("institution", values.institutionName);
        formData.append("discipline", values.courseDiscipline);
        formData.append("program", values.degree);
        formData.append("class_of_degree", values.classOfDegree);
        formData.append("year", values.yearObtained.toString());
        formData.append("degree", values.degree);

        try {
          const basicResponse = await trainerRegistration.updateUserEducation(
            formData
          );
          if (basicResponse) {
            toast({
              title: "Registration",
              description: "Education updated successfully",
              status: "success",
            });
            nextPage();
          }
        } catch (error) {
          toast({
            title: "Registration",
            description: "Something went Wrong. Try again later",
            status: "error",
          });
        }
      } else {
        const formData = new FormData();
        formData.append("institution", values.institutionName);
        formData.append("discipline", values.courseDiscipline);
        formData.append("program", values.degree);
        formData.append("class_of_degree", values.classOfDegree);
        formData.append("year", values.yearObtained.toString());
        formData.append("degree", values.degree);

        try {
          const basicResponse = await trainerRegistration.updateUserEducation(
            formData
          );
          if (basicResponse) {
            toast({
              title: "Registration",
              description: "Education updated successfully",
              status: "success",
            });
            nextPage();
          }
        } catch (error) {
          toast({
            title: "Registration",
            description: "something went wrong",
            status: "error",
          });
        }
      }
    },
  });

  const setUserEducation = () => {
    if (education) {
      formik.setValues({
        institutionName: education.institution,
        courseDiscipline: education.discipline,
        programOfStudy: education.program,
        classOfDegree: education.class_of_degree,
        yearObtained: education.year,
        degree: education.degree,
        certificate: education.doc,
      });
    }
  };

  const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;

    if (value) {
      const fileName = e.target.files?.item(0)?.name as string;
      setFilename(fileName);

      const fileType = e.target.files?.item(0)?.type;

      const file = e.target.files?.item(0) as File;
      setbatchFile(file);

      // if ((fileType?.split('/').at(1) !== 'pdf') || (fileType?.split('/').at(1) !== 'jpg') || (fileType?.split('/').at(1) !== 'png')) {
      //     // formik.setErrors({ certificate: 'Only PDF,jpg,png file format is supported' });
      //     return;
      // }

      if (
        fileType?.split("/")[1]?.toLowerCase() !== "pdf" ||
        fileType?.split("/")[1]?.toLowerCase() !== "jpg" ||
        fileType?.split("/")[1]?.toLowerCase() !== "png"
      ) {
        return;
      }
    } else {
      setFilename("");
      setbatchFile(null);
    }

    formik.handleChange(e);
  };

  return (
    <Box px={6} mb="50px">
      <Flex justifyContent="center" mb="35px">
        <Text mx="auto" fontSize="32px" fontWeight="800">
          Education Profile
        </Text>
      </Flex>
      <Text mb="35px" color="#9E9E9E" fontSize="14px">
        All fields in{" "}
        <Text as="span" color="red">
          (*){" "}
        </Text>
        are required
      </Text>

      <form onSubmit={formik.handleSubmit}>
        <FormControl
          mt={6}
          mb="25px"
          isInvalid={
            formik.errors.institutionName && formik.touched.institutionName
              ? true
              : false
          }
        >
          <FormLabel fontWeight="600" color="#616161" fontSize={13}>
            {" "}
            Name of Institution{" "}
            <Text as="span" color="red">
              {" "}
              *{" "}
            </Text>
          </FormLabel>
          <Input
            bg="inputText.500"
            placeholder="Enter institution name"
            value={formik.values.institutionName}
            name="institutionName"
            onChange={formik.handleChange}
            fontSize={12}
          />
          <FormErrorMessage fontSize={12}>
            {formik.errors.institutionName}
          </FormErrorMessage>
        </FormControl>
        <FormControl
          mb="25px"
          mt={6}
          isInvalid={
            formik.errors.courseDiscipline && formik.touched.courseDiscipline
              ? true
              : false
          }
        >
          <FormLabel fontWeight="600" color="#616161" fontSize={13}>
            Course / Discipline{" "}
            <Text as="span" color="red">
              {" "}
              *{" "}
            </Text>
          </FormLabel>
          <Input
            bg="inputText.500"
            placeholder="Enter course discipline"
            value={formik.values.courseDiscipline}
            name="courseDiscipline"
            onChange={formik.handleChange}
            fontSize={12}
          />
          <FormErrorMessage fontSize={12}>
            {formik.errors.courseDiscipline}
          </FormErrorMessage>
        </FormControl>

        <FormControl
          mb="25px"
          mt={6}
          isInvalid={
            formik.errors.degree && formik.touched.degree ? true : false
          }
        >
          <FormLabel fontWeight="600" color="#616161" fontSize={13}>
            Program of Study{" "}
            <Text as="span" color="red">
              {" "}
              *{" "}
            </Text>
          </FormLabel>
          <Select
            variant="outline"
            bg="inputText.500"
            size="sm"
            placeholder="Select program"
            value={formik.values.degree}
            name="degree"
            onChange={formik.handleChange}
            fontSize={12}
            color="brand.subtitle"
          >
            {degree.map((degree) => (
              <option key={degree} value={degree}>
                {" "}
                {degree}{" "}
              </option>
            ))}
          </Select>
          <FormErrorMessage fontSize={12}>
            {formik.errors.degree}
          </FormErrorMessage>
        </FormControl>
        <FormControl
          mb="25px"
          mt={6}
          isInvalid={
            formik.errors.classOfDegree && formik.touched.classOfDegree
              ? true
              : false
          }
        >
          <FormLabel fontWeight="600" color="#616161" fontSize={13}>
            Class of Degree{" "}
            <Text as="span" color="red">
              {" "}
              *{" "}
            </Text>
          </FormLabel>
          <Select
            variant="outline"
            bg="inputText.500"
            size="sm"
            placeholder="Class of Degree"
            value={formik.values.classOfDegree}
            name="classOfDegree"
            onChange={formik.handleChange}
            fontSize={12}
            color="brand.subtitle"
          >
            {cod.map((degree) => (
              <option key={degree} value={degree}>
                {" "}
                {degree}{" "}
              </option>
            ))}
          </Select>
          <FormErrorMessage fontSize={12}>
            {formik.errors.classOfDegree}
          </FormErrorMessage>
        </FormControl>
        <FormControl
          mb="25px"
          mt={6}
          isInvalid={
            formik.errors.yearObtained && formik.touched.yearObtained
              ? true
              : false
          }
        >
          <FormLabel fontWeight="600" color="#616161" fontSize={13}>
            Year Obtained{" "}
            <Text as="span" color="red">
              {" "}
              *{" "}
            </Text>
          </FormLabel>
          <Select
            variant="outline"
            bg="inputText.500"
            size="sm"
            placeholder="Select Year"
            value={formik.values.yearObtained}
            name="yearObtained"
            onChange={formik.handleChange}
            fontSize={12}
            color="brand.subtitle"
          >
            {years.map((each, index) => (
              <option key={index} value={each}>
                {" "}
                {each}{" "}
              </option>
            ))}
          </Select>
          <FormErrorMessage fontSize={12}>
            {formik.errors.yearObtained}
          </FormErrorMessage>
        </FormControl>
        {education?.doc ? (
          <Box>
            <Text>{education.doc}</Text>
          </Box>
        ) : filename ? (
          <Box>
            <Table variant="unstyled">
              <Thead fontWeight="semibold">
                <Tr color="brand.subtitle" fontSize={14}>
                  <Td>Filename</Td>
                  <Td>Type</Td>

                  <Td>Size</Td>
                </Tr>
              </Thead>

              <Tbody>
                <Tr fontSize={13} color="brand.subtitle">
                  <Td maxW="20em">{filename}</Td>
                  <Td>{batchFile?.type}</Td>
                  <Td>{uploadFileSize}</Td>
                </Tr>
              </Tbody>
            </Table>
          </Box>
        ) : (
          <FormControl mr={10}>
            <FormLabel fontWeight="600" color="#616161" fontSize={13}>
              Upload Certificate
            </FormLabel>
            <Text fontWeight="400" color="#959595" fontSize="14px">
              Upload a PDF format of the certificate. (Not larger than 2MB)
            </Text>

            <input
              accept="application/pdf"
              type="file"
              name="certificate"
              ref={inputRef}
              value={formik.values.certificate}
              onChange={(e) => handleFileChange(e)}
              style={{ display: "none" }}
            ></input>
            <Input
              cursor="pointer"
              placeholder="No file selected"
              defaultValue={filename}
              mt="10px"
              borderColor="#eeeeee"
              fontSize={14}
              bg="#fafafa"
              onClick={() => inputRef?.current?.click()}
              border="2px dashed"
              borderRadius={2}
            />
          </FormControl>
        )}

        <Flex
          mb="100px"
          justifyContent="space-between"
          alignItems="flex-end"
          mt={6}
        >
          <Button
            onClick={prePage}
            colorScheme="white"
            color="red"
            size="sm"
            fontSize={11}
            borderRadius={10}
            px={10}
          >
            PREVIOUS
          </Button>
          <HStack alignItems={"flex-end"}>
            <Button
              colorScheme="white"
              color="red"
              size="sm"
              fontSize={11}
              borderRadius={10}
              px={10}
            >
              Save & Exit
            </Button>
            <Button
              py="13px"
              px="30px"
              mt="30px"
              type="submit"
              fontSize={11}
              isLoading={formik.isSubmitting}
              borderRadius={0}
              colorScheme="red"
              size="sm"
            >
              NEXT
            </Button>
          </HStack>
        </Flex>
      </form>
    </Box>
  );
};

export default EducationProfile;
